import * as H from "history";
import * as React from "react";
import { Redirect } from "react-router-dom";
import AuthApplyClientDemoRegisterComponent from "./auth_apply_client_demo_register";
import AuthApplyClientLafoolRegisterComponent from "./auth_apply_client_lafool_register";
import AuthApplyClientRegisterComponent from "./auth_apply_client_register";
import AuthApplyClientThanksComponent from "./auth_apply_client_thanks";
import AuthCustomerCreateComponent from "./auth_customer_create";
import AuthLoginComponent from "./auth_login";
import AuthProCreateComponent from "./auth_pro_create";
import AuthSuperEngineerCreateComponent from "./auth_super_enginner_create";

interface IProps {
  location: H.Location;
  logoutDispatcher: () => void;
  handleCallLogin: (values: any) => void;
  handleCallCreate: (values: any) => void;
  handleCallSuperEngineerCreate: (values: any) => void;
  handleCallProCreate: (values: any) => void;
  handleApplyClient: (values: any) => void;
  handleApplyClientForDemo: (values: any) => void;
  handleApplyClientByLafool: (values: any) => void;
  handleApplyClientByLafoolMedical: (value: any) => void;
}

const AuthComponent: React.FC<IProps> = (props) => {
  const {
    location,
    logoutDispatcher,
    handleCallLogin,
    handleCallCreate,
    handleCallSuperEngineerCreate,
    handleCallProCreate,
    handleApplyClient,
    handleApplyClientForDemo,
    handleApplyClientByLafool,
    handleApplyClientByLafoolMedical,
  } = props;

  const pathname = location.pathname;

  let res: JSX.Element;
  switch (true) {
    // logout画面　画面無し
    case /^\/logout/.test(pathname): {
      logoutDispatcher();
      res = <Redirect to="/login" />;
      break;
    }
    // login画面
    case /^\/login/.test(pathname): {
      res = <AuthLoginComponent handleCallLogin={handleCallLogin} />;
      break;
    }
    // customer_create画面
    case /^\/customer\/_create/.test(pathname): {
      res = <AuthCustomerCreateComponent handleCallCreate={handleCallCreate} />;
      break;
    }
    // super_engineer_create画面
    case /^\/super_engineer\/_create/.test(pathname): {
      res = (
        <AuthSuperEngineerCreateComponent
          handleCallCreate={handleCallSuperEngineerCreate}
        />
      );
      break;
    }
    // pro_create画面
    case /^\/pro\/_create/.test(pathname): {
      res = <AuthProCreateComponent handleCallCreate={handleCallProCreate} />;
      break;
    }
    // apply_client画面
    case /^\/apply_client\/_register/.test(pathname): {
      res = (
        <AuthApplyClientRegisterComponent
          handleApplyClient={handleApplyClient}
        />
      );
      break;
    }

    // apply_client画面
    case /^\/apply_client\/_alliance_partner/.test(pathname): {
      res = (
        <AuthApplyClientDemoRegisterComponent
          handleApplyClient={handleApplyClientForDemo}
        />
      );
      break;
    }

    // apply_client lafool 画面
    case /^\/apply_client\/lafool\/_register/.test(pathname): {
      res = (
        <AuthApplyClientLafoolRegisterComponent
          isLafoolMedical={false}
          handleApplyClientByLafool={handleApplyClientByLafool}
          handleApplyClientByLafoolMedical={handleApplyClientByLafoolMedical}
        />
      );
      break;
    }

    // apply_client lafool medical 画面
    case /^\/apply_client\/lafool_medical\/_register/.test(pathname): {
      res = (
        <AuthApplyClientLafoolRegisterComponent
          isLafoolMedical={true}
          handleApplyClientByLafool={handleApplyClientByLafool}
          handleApplyClientByLafoolMedical={handleApplyClientByLafoolMedical}
        />
      );
      break;
    }

    // apply_client thanks 画面
    case /^\/apply_client\/thanks/.test(pathname): {
      res = <AuthApplyClientThanksComponent />;
      break;
    }

    default: {
      res = <div />;
    }
  }

  return res;
};

export default AuthComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/auth/auth.tsx